<template>
  <div class="language">
    <button
        v-for="(option, index) in options"
        :key="option.code"
        class="language__option"
        :class="{'language__option--active': option.code === language}"
        type="button"
        :lang="option.code"
        :aria-pressed="option.code === language"
        @click="onLanguageClicked(option.code)">
      {{ option.label }}<span v-if="index < options.length - 1" class="language__divider" aria-hidden="true">|</span>
    </button>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {messages, SUPPORTED_LANGUAGES} from "@/i18n";
import {setLanguage} from "@/functions/setLanguage";

export default {
  name: 'LanguageToggle',
  computed: {
    ...mapState(['language']),
    options() {
      return SUPPORTED_LANGUAGES.map(code => ({code, label: messages[code].languageLabel}));
    }
  },
  methods: {
    onLanguageClicked(code) {
      setLanguage(code);
    }
  }
}
</script>

<style scoped>
.language {
  display: flex;
  align-items: center;
}

.language__option {
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  font-size: calc(11 * var(--u));
  line-height: 1;
  font-weight: 500;
  color: rgba(77, 89, 101, 0.45);
  transition: color 0.2s;
}

.language__option--active {
  font-weight: 700;
  color: var(--slate);
}

.language__divider {
  margin: 0 calc(4 * var(--u));
  font-weight: 400;
  color: rgba(77, 89, 101, 0.3);
}
</style>
